// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';

const SVG = styled.svg`
    height: calc(10px + 1vmin);
    width: 100%;
`;
const G = styled.g`
    fill: ${({theme}) => theme.body};
`;

const ShadeOverlay = ({ children, ...props }) => {
    return (
        <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 140" preserveAspectRatio="none">
            <G>
                <path d="M725.29 101.2C325.22 122.48 0 0 0 0v140h1280V0s-154.64 79.92-554.71 101.2z" fillOpacity=".5"></path>
                <path d="M556.45 119.74C953.41 140 1280 14 1280 14v126H0V0s159.5 99.48 556.45 119.74z" fillOpacity=".7"></path>
                <path d="M640 140c353.46 0 640-140 640-139v140H0V0s286.54 140 640 140z"></path>
            </G>
        </SVG>
    );
}

export default ShadeOverlay;